import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JourneyStep } from '../../../pages/journey/journey.component';
import { ZorroModule } from '../../../../modules/zorro.module';
import { AngularModule } from '../../../../modules/angular.module';
import { PlayerHeaderComponent } from './player-header/player-header.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { Activity } from '@mira-avant/mtlibs';
import { HeaderInstructionsComponent } from './header-instructions/header-instructions.component';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [
		AngularModule,
		ZorroModule,
		PlayerHeaderComponent,
		PageHeaderComponent,
		HeaderInstructionsComponent,
	],
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss',
})
export class HeaderComponent {
	@Output('onBack') public onBack: EventEmitter<void> = new EventEmitter<void>();
	@Output('up') public up: EventEmitter<void> = new EventEmitter<void>();
	@Output('info') public info: EventEmitter<void> = new EventEmitter<void>();
	@Output('next') public next: EventEmitter<void> = new EventEmitter<void>();
	@Input('enableNext') public enableNext: boolean = false;
	@Input('journeyStep') public journeyStep: JourneyStep | undefined;
	@Input('useOnBack') public useOnBack: boolean = false;
	@Input('useWindowBack') public useWindowBack: boolean = false;
	@Input('back') public back: string[] = [];
	@Input('activity') public activity: Activity | undefined;

	public JourneyStep = JourneyStep;
	public showInstructionsPopup: boolean = false;

	public showInstructions(): void {
		//this is actually a toggle
		if (this.showInstructionsPopup) {
			this.hideInstructions();
		} else {
			this.showInstructionsPopup = true;
		}
	}

	public hideInstructions(): void {
		this.showInstructionsPopup = false;
	}
}
